@import '../../style/index';

@include host {
  display: inline-block;

  .link {
    color: var(--colors-dark-base);
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: rem-calc(8px);

    &:hover {
      color: var(--colors-dark-medium);
      text-decoration: none;
    }

    &:focus {
      outline: 2px solid;
      border-radius: 1px;
    }

    &:visited:not(:hover) {
      color: var(--colors-dark-base);
    }

    .icon-container {
      display: flex;
      align-items: center;
      position: relative;
      width: rem-calc(18px);
      height: rem-calc(12px);
      fill: currentcolor;
      flex: 1 0 auto;

      .icon {
        position: absolute;
        top: rem-calc(-3px);
      }
    }

    &--richtext {
      @include link-richtext();
    }
  }

  .align--baseline {
    align-items: baseline;
  }

  .direction--reverse {
    flex-direction: row-reverse;
  }
}

.high-contrast {
  @include host {
    a {
      color: red;
    }
  }
}

:host([type='footer']) {
  rcm-icon {
    fill: var(--colors-dark-base);
  }

  a:hover {
    rcm-icon {
      fill: var(--colors-dark-medium);
    }
  }
}
